export default "__VITE_ASSET__DYYfFjWl__"